// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigationPanel {
  padding: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/containers/problem-detail/problem-detail.component.scss","webpack://./../../../../../RAP%20(.NET%2010)/RAP%20-%20UAT%20(.NET%2010)/rap/RAP/ClientApp/src/app/containers/problem-detail/problem-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;ACCJ","sourcesContent":[".navigationPanel {\r\n    padding: 0px !important;\r\n}",".navigationPanel {\n  padding: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
